import { createEmotionCache } from '@inflearn/ds-react';

export const styleCache = createEmotionCache({ key: 'mantine', prepend: true });
